import { Injectable, InjectionToken, inject } from '@angular/core';
import { Currency } from '../../domain/market.domain';
import { ExchangeRate, ExchangeRates, RateSource } from '../../domain/exchange-rate.domain';

export { ExchangeRate, ExchangeRates, RateSource } from '../../domain/exchange-rate.domain';

export const EXCHANGE_RATES_CONFIGURATION = new InjectionToken<ExchangeRates>('fxRates');

@Injectable({
  providedIn: 'root'
})
export class ExchangeRateService {
  private readonly exchangeRates = inject<ExchangeRates>(EXCHANGE_RATES_CONFIGURATION);

  /**
   * @param  fromCurrency the starting point for this transaction
   * @param  toCurrency the end point for this transaction
   * @param  source of rate data ie; IBM, MPOWER (defaults to IBM)
   * @description
   * matches a rate to a given exchange to and from (source is optional)
   */
  getExchangeRate(fromCurrency: Currency, toCurrency: Currency, source: RateSource = RateSource.IBM): number {
    return this.getRate(fromCurrency, toCurrency, this.getSourceRates(source));
  }

  // Return the array of rates for a given source ie IBM, MPOWER
  private getSourceRates(source: RateSource): Array<ExchangeRate> {
    return this.exchangeRates[source];
  }

  // match the rate for this exchange to and from in array of rates
  private getRate(from: Currency, to: Currency, sourceRates: Array<ExchangeRate>): number | undefined {
    let foundRate;

    if (sourceRates !== undefined) {
      foundRate = sourceRates.find((element: ExchangeRate): boolean => element.from === from && element.to === to);
    }

    return foundRate ? foundRate.rate : foundRate ;

  }
}
